import { DatabaseFieldType } from '@databases/types/database';
import { type MessageDescriptor } from 'react-intl-next';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';

import { messages } from './messages';

export const getFieldTypeName = (
  fieldType: DatabaseFieldType,
  isLiveDocEnabled?: boolean
) => {
  const definitions: {
    [key in DatabaseFieldType]: MessageDescriptor;
  } = {
    [DatabaseFieldType.TEXT]: messages['field-settings.type-text'],
    [DatabaseFieldType.AI_SUMMARY]: messages['field-settings.type-ai-summary'],
    [DatabaseFieldType.ATTACHMENT]: messages['field-settings.type-attachment'],
    [DatabaseFieldType.NUMBER]: messages['field-settings.type-number'],
    [DatabaseFieldType.DATE]: messages['field-settings.type-date'],
    [DatabaseFieldType.CHECKBOX]: messages['field-settings.type-checkbox'],
    [DatabaseFieldType.SELECT]: messages['field-settings.type-tag'],
    [DatabaseFieldType.USER]: messages['field-settings.type-user'],
    [DatabaseFieldType.HYPERLINK]: messages['field-settings.type-link'],
    [DatabaseFieldType.PAGE_LINK]: isLiveDocEnabled
      ? messages['field-settings.type-content-link']
      : messages['field-settings.type-page-link'],
    [DatabaseFieldType.PAGE_STATUS]: isLiveDocEnabled
      ? messages['field-settings.type-content-status']
      : messages['field-settings.type-page-status'],
    [DatabaseFieldType.PAGE_LABELS]: isLiveDocEnabled
      ? messages['field-settings.type-content-label']
      : messages['field-settings.type-page-label'],
    [DatabaseFieldType.PAGE_DETAILS]: isLiveDocEnabled
      ? messages['field-settings.type-content-details']
      : messages['field-settings.type-page-details'],
    [DatabaseFieldType.ENTRY_LINK]: messages['field-settings.type-entry-link'],
    [DatabaseFieldType.ENTRY_DETAILS]: messages['field-settings.type-entry-details'],
    [DatabaseFieldType.BACKLINK]: messages['field-settings.type-entry-backlink'],
    [DatabaseFieldType.JIRA_ISSUE]: isFeatureFlagEnabled(
      'canvas-issue-terminology-refresh-update'
    )
      ? messages['field-settings.type-jira-issue-issue-terminology-refresh-m4']
      : messages['field-settings.type-jira-issue'],
    [DatabaseFieldType.JIRA_ISSUE_DETAILS]: isFeatureFlagEnabled(
      'canvas-issue-terminology-refresh-update'
    )
      ? messages['field-settings.type-jira-issue-details-issue-terminology-refresh-m4']
      : messages['field-settings.type-jira-issue-details'],
  };

  return definitions[fieldType];
};
